
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.935 15.833c.494 0 .898.405.898.899v1.37a.901.901 0 01-.898.898h-1.37a.901.901 0 01-.898-.898v-1.37c0-.494.404-.899.898-.899zM8.602 3.167c.494 0 .898.404.898.898v1.37c0 .494.404.898.898.898h1.37a.901.901 0 00.899-.898v-1.37c0-.494.404-.898.898-.898h1.37c.494 0 .898.404.898.898v1.37c0 .494.405.898.899.898h1.37c.494 0 .898.405.898.899v1.37a.901.901 0 01-.898.898h-1.37a.901.901 0 00-.899.898v1.37a.901.901 0 01-.898.899h-1.37a.901.901 0 01-.898-.899v-1.37a.901.901 0 00-.899-.898h-1.37a.901.901 0 00-.898.898v1.37c0 .494.404.899.898.899h1.37c.494 0 .899.404.899.898v1.37a.901.901 0 01-.899.898h-1.37a.901.901 0 00-.898.899v1.37a.901.901 0 01-.898.898H.898A.901.901 0 010 18.102v-7.704C0 9.904.404 9.5.898 9.5h4.537a.901.901 0 00.898-.898V4.065c0-.494.405-.898.899-.898zm-2.156 8.489h-3.37a.901.901 0 00-.898.898v3.37c0 .493.405.898.899.898h3.369a.901.901 0 00.898-.899v-3.369a.901.901 0 00-.898-.898zm11.656 1.01c.494 0 .898.405.898.899v1.37a.901.901 0 01-.898.898h-1.37a.901.901 0 01-.899-.898v-1.37c0-.494.405-.898.899-.898zm-12.981.315c.494 0 .898.404.898.898v.742a.901.901 0 01-.898.898h-.742a.901.901 0 01-.898-.898v-.742c0-.494.404-.898.898-.898zM5.435 0c.494 0 .898.404.898.898v1.37a.901.901 0 01-.898.899h-1.37a.901.901 0 00-.898.898v1.37a.901.901 0 01-.899.898H.898A.901.901 0 010 5.435V.898C0 .404.404 0 .898 0zm12.667 0c.494 0 .898.404.898.898v1.37a.901.901 0 01-.898.899h-1.37a.901.901 0 01-.899-.899V.898c0-.494.405-.898.899-.898zm-6.334 0c.494 0 .899.404.899.898v1.37a.901.901 0 01-.899.899h-1.37a.901.901 0 01-.898-.899V.898c0-.494.404-.898.898-.898z","fill":"#F8E8F4","fill-rule":"nonzero"}})])
          )
        }
      }
    